/* eslint-disable id-length */
import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { TradeRadioLoader } from './TradeRadioLoader';

export const TradeRadioMiniPopupProvider = ({ store, data }) => {
    if (
        PULSE.core.url.getParam('webview') === 'true' ||
        window.IS_ARTICLE_API === true
    ) {
        return false;
    }

    return (
        <Provider store={store}>
            <TradeRadioLoader {...data} isMiniPopup />
        </Provider>
    );
};

TradeRadioMiniPopupProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
